import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import Modal from '../../../common/modal/Modal';
import { putCargoCorporateCreditChangePassword } from '../../../../actions';
import CargoCorporateCreditChangePasswordForm from './CargoCorporateCreditChangePasswordForm';

export const CargoCorporateCreditChangePasswordButton = ({
  cargoCorporateCreditId,
  dispatchPutCargoCorporateCreditChangePassword,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState(null);

  const closeModal = () => setShowModal(false);

  const onModalSubmit = async ({ secretCode }) => {
    await dispatchPutCargoCorporateCreditChangePassword({
      cargoCorporateCreditId,
      secretCode,
    });
    setShowModal(false);
    setModalBody(null);
  };

  const openModal = () => {
    const newModalBody = (
      <CargoCorporateCreditChangePasswordForm
        onCancel={closeModal}
        handleProcess={onModalSubmit}
      />
    );
    setModalBody(newModalBody);
    setShowModal(true);
  };

  return (
    <>
      <Modal
        show={showModal}
        title="Cambiar Contraseña"
        body={modalBody}
        size="lg"
      />
      <Button color="warning" onClick={openModal}>
        <i className="fa fa-key" /> Cambiar Clave
      </Button>
    </>
  );
};

CargoCorporateCreditChangePasswordButton.propTypes = {
  cargoCorporateCreditId: PropTypes.number.isRequired,
  dispatchPutCargoCorporateCreditChangePassword: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPutCargoCorporateCreditChangePassword:
    putCargoCorporateCreditChangePassword,
};

const connectedComponent = connect(
  null,
  mapDispatchToProps,
)(CargoCorporateCreditChangePasswordButton);

export default connectedComponent;
